module.exports = __webpack_public_path__ + "static/FakedesOutline-40e28562bf3904a4917059137ee5971a.woff";